import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles((theme) => ({
  inputWrapper: {
    display: 'flex',
    width: '100%',
    position: 'relative',
  },

  form: {
    width: '100%',
    marginTop: theme.spacing(1.6),

    heightInput: {
      marginTop: theme.spacing(2),
      width: '100%',
    },
  },

}));

export default useStyles;
